import { PlatformRequirementProblemType } from '@client/graphql/__generated__/types';

const platformRequirementProblemTypeLabels: Record<
  PlatformRequirementProblemType,
  string
> = {
  [PlatformRequirementProblemType.CHECKLIST_ATTACHED_DOCUMENT_MISMATCH]:
    'Document mismatch',
};

/**
 * Returns the short user-facing reason for a checklist issue, shown beside the
 * checklist item name on the compact agent-facing rows.
 *
 * Deliberately not the issue's `message`: that is a per-document sentence
 * ("<doc> is attached to <requirement>, but that requirement allows <values>.")
 * built server-side, far too long for a one-line row and scoped to a single
 * attachment rather than the group. The full evidence lives in the hover
 * tooltip instead.
 *
 * A total `Record` rather than a lookup with a fallback, so adding a second
 * problem type fails the build here instead of silently rendering a blank or
 * mislabelled reason. Leaf module for the same reason as
 * {@link formatPlatformRequirementIssueStatus}.
 */
export const formatPlatformRequirementProblemType = (
  problemType: PlatformRequirementProblemType
): string => platformRequirementProblemTypeLabels[problemType];
